import React, { useState, useEffect } from "react"
import { Layout, Table, message, Form } from "antd"
import { DownOutlined } from "@ant-design/icons"
import axios from "axios"
import SideNavBar from "../../Components/SideBar/Sidebar"
import Navbar from "../../Components/Support/Header"
// import './StatutoryReporting.css'
import "../../GlobalCss/SPF/StatutoryReporting.css"
import Cookies from "js-cookie"
const { Header, Content } = Layout

const StatutoryReporting = () => {
    const jwtToken = Cookies.get("jwt_token")
    const username = Cookies.get("first_name")
    const [form] = Form.useForm()
    const [ActivityLogData, SetActivityLogData] = useState([])

    const dataSource = [
        {
            key: '1',
            ReportFrequency: 'Weekly',
            ReportName: 'Non Exempt employees with more than 40Reg hours',
            DueBy: 'Friday',
        },
        {
            key: '2',
            ReportFrequency: 'Weekly',
            ReportName: 'Payroll Hours - Paid vs Billed',
            DueBy: 'Friday',
        },
        {
            key: '3',
            ReportFrequency: 'Weekly',
            ReportName: 'H S A',
            DueBy: 'Monday',
        },
        {
            key: '4',
            ReportFrequency: 'Weekly',
            ReportName: 'Positive Pay Reporting to AP Team',
            DueBy: 'Thursday & Friday',
        },
        {
            key: '5',
            ReportFrequency: 'Weekly',
            ReportName: 'Payroll Cost Trend',
            DueBy: 'Friday',
        },
        {
            key: '6',
            ReportFrequency: 'Monthly',
            ReportName: 'PGE SFHCO',
            DueBy: 'First Friday of the Month',
        },
        {
            key: '7',
            ReportFrequency: 'Monthly',
            ReportName: 'Corporate Employee Headcount',
            DueBy: '10th of every month',
        },
        {
            key: '8',
            ReportFrequency: 'Monthly',
            ReportName: 'BOL Statistics (NJ & FL) -HC',
            DueBy: 'Fourth Friday',
        },
        {
            key: '9',
            ReportFrequency: 'Quarterly',
            ReportName: 'State Wage Report (WA, WI, NM, WY, WV, ND)',
            DueBy: 'Second Friday of April, July, Oct, Jan',
        },
        {
            key: '10',
            ReportFrequency: 'Quarterly',
            ReportName: 'ABC Wage Report',
            DueBy: 'Second Friday of April, July, Oct, Jan',
        },
        {
            key: '11',
            ReportFrequency: 'Quarterly',
            ReportName: 'SFHCO',
            DueBy: 'Second Friday of April, July, Oct, Jan',
        },
        {
            key: '12',
            ReportFrequency: 'Yearly',
            ReportName: 'Workers Comp',
            DueBy: 'Upon email request',
        },
        {
            key: '13',
            ReportFrequency: 'Yearly',
            ReportName: 'Census',
            DueBy: 'Upon email request',
        },
        {
            key: '14',
            ReportFrequency: 'Yearly',
            ReportName: 'NYSIF',
            DueBy: 'Upon email request',
        },
        {
            key: '15',
            ReportFrequency: 'Yearly',
            ReportName: 'SF Business Regist Report',
            DueBy: 'Upon email request',
        },
        {
            key: '16',
            ReportFrequency: 'Yearly',
            ReportName: 'CA Enivronment Fee - Data reporting',
            DueBy: 'Upon email request',
        },
        {
            key: '17',
            ReportFrequency: 'Yearly',
            ReportName: 'W2 Box DD  - ER Health Insurance Cost - Medical Only',
            DueBy: 'Third Friday of December',
        },
    ]

    const Reportcolumns = [
        {
            title: 'Report Frequency',
            dataIndex: 'ReportFrequency',
            key: 'Report Frequency',
            width: 140,
            filters: [
                {
                    text: 'Weekly',
                    value: 'Weekly',
                },
                {
                    text: 'Monthly',
                    value: 'Monthly',
                },
                {
                    text: 'Quarterly',
                    value: 'Quarterly',
                },
                {
                    text: 'Yearly',
                    value: 'Yearly',
                },
            ],
            onFilter: (value, record) => {
                if (value === 'Yearly') {
                    return record.ReportFrequency && record.ReportFrequency.startsWith('Yearly');
                } else if (value === 'Quarterly') {
                    return record.ReportFrequency && record.ReportFrequency.startsWith('Quarterly');
                } else if (value === 'Monthly') {
                    return record.ReportFrequency && record.ReportFrequency.startsWith('Monthly');
                } else if (value === 'Weekly') {
                    return record.ReportFrequency && record.ReportFrequency.startsWith('Weekly');
                }
                return false;
            },
            filterIcon: (filtered) => (
                <DownOutlined style={{ color: filtered ? "rgba(0, 39, 102, 0.39)" : "rgba(0, 39, 102, 0.39)" }} />),
        },
        {
            title: 'Report Name',
            dataIndex: 'ReportName',
            key: 'Report Name',
            width: 100,
        },
        {
            title: 'Due By',
            dataIndex: 'DueBy',
            key: 'Due By',
        },
    ]

    const Activitycolumns = [
        {
            title: 'Associate Name',
            dataIndex: 'UserName',
            key: 'Associate Name',
            width: 140,
        },
        {
            title: 'Reports Pulled Time',
            dataIndex: 'ActivityLog',
            key: 'Reports Pulled Time',
            width: 240,
        },
    ]

    const PostActivityLogData = async (report, curdate) => {
        const formattedDateTime = curdate.toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        })
        // const reportName = encodeURIComponent(report)
        /// const user = encodeURIComponent(username)
        try {
            let url = `${process.env.REACT_APP_BASE_URL}StatutoryReport/ActivityLog/${report}/${formattedDateTime}/uName?uName=${username}`;
            const data = {
                uName: username
            }
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                }
            }
            const response = await axios.post(url, data, config)
            if (response.data.statusCode == 200) {
                GetActivityLogData()
                if (report === "Non Exempt employees with more than 40Reg hours"){
                    window.location.href = "./reportingtable"
                }
                else if(report === "Payroll Hours - Paid vs Billed"){
                    window.location.href = "./paidvsbilled"
                }
            }
        }
        catch (err) {
            message.error("Error while posting activity log data!")
        }
    }
    const GetActivityLogData = async () => {
        try {
            let url = `${process.env.REACT_APP_BASE_URL}StatutoryReport/ActivityLog`
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                }
            }
            const response = await axios.get(url, config)
            if (response.data.statusCode == 200) {
                const res = response.data.payload
                const data = JSON.parse(res)
                SetActivityLogData(data)
            }
        }
        catch (error) {
            message.error("Error while fetching activity log data!")
        }
    }
    useEffect(() => {
        GetActivityLogData();
    }, []);
    return (
        <>
            <Layout style={{ backgroundColor: "white", height: "100vh", display: "flex", overflow: "hidden" }} >
                <SideNavBar />
                <Layout style={{ backgroundColor: "white", overflow: "hidden" }}>
                    <Header className="preview-header-class"><Navbar /></Header>
                    <Content className="preview-content">
                        <div className="reporting-title">Reporting</div>
                        <div className="layouts-styling">
                            <div>
                                <Layout className="reporting-queue">
                                    <h3 className="reports-queue-heading">Reports in Queue</h3>
                                    <div className="reports-queue-table-div">
                                        <Table className="reports-queue-table"
                                            columns={Reportcolumns}
                                            dataSource={dataSource}
                                            scroll={{ x: "max-content" }}
                                            pagination={false}
                                            size="small"
                                            onRow={(record, rowIndex) => {
                                                return {
                                                    onClick: event => {
                                                        // PostActivityLogData(record.ReportName, new Date())
                                                        if (record.ReportName === "Non Exempt employees with more than 40Reg hours") {
                                                            PostActivityLogData(record.ReportName, new Date())
                                                            // window.location.href = "./reportingtable"
                                                        }
                                                        else if (record.ReportName === "Payroll Hours - Paid vs Billed") {
                                                            PostActivityLogData(record.ReportName, new Date())
                                                            // window.location.href = "./paidvsbilled"
                                                        }
                                                    },
                                                }
                                            }}
                                        />
                                    </div>
                                </Layout>
                            </div>
                            <div>
                                <Layout className="activitylog-queue">
                                    <h3 className="reports-queue-heading">Activity Log</h3>
                                    <div className="reports-queue-table-div">
                                        {
                                            ActivityLogData ?
                                                <Form form={form} component={false}>
                                                    <Table className="reports-queue-table"
                                                        columns={Activitycolumns}
                                                        dataSource={ActivityLogData.map(item => ({ ...item, key: item.Id }))}
                                                        scroll={{ x: "max-content", y: 350 }}
                                                        pagination={false}
                                                        size="small"
                                                    />
                                                </Form>
                                                : null
                                        }
                                    </div>
                                </Layout>
                            </div>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        </>
    )
}
export default StatutoryReporting